import { createConfig, http } from 'wagmi';
import { sei, seiTestnet } from './chains';

// Get network from env, default to testnet
const isTestnet = import.meta.env.VITE_IS_TESTNET === 'true';

// Export for use in other parts of the app
export const activeChain = isTestnet ? seiTestnet : sei;

// Include both chains to allow switching between them
export const wagmiConfig = createConfig({
  chains: [sei, seiTestnet],
  transports: {
    [sei.id]: http(),
    [seiTestnet.id]: http(),
  },
});
